import useSWR from 'swr';

import useAuth from 'hooks/useAuth';
import API from 'services/endpoints';
import { buildUrl, fetcher } from 'services/fetcher';

// =============================================================================
// useMyPermissions — what the signed-in login's account allows
// (GET /user/permissions): downloading data, changing units / timezone /
// download preferences, renaming PheNodes and setting their WiFi (switched
// per subaccount; Account Settings drops its Devices tab when both are off),
// and whether it's an account admin (managesAccounts: the Admin Panel's Users
// and Settings tabs).
// =============================================================================
//
// Until the answer arrives, or if it fails, everything counts as allowed: the
// API refuses with a 403 regardless, so this is a UX layer, never the gate, and
// a slow network shouldn't grey out every Download button. managesAccounts is
// the exception: it only ever adds a menu entry, so it stays false until the
// API says otherwise.
//
// Polls once a minute and on window focus, so an admin's change reaches an
// open dashboard without a reload.

export default function useMyPermissions() {
  const { accessToken } = useAuth();
  const key = accessToken ? [buildUrl(API.user.permissions), accessToken] : null;
  const { data, isLoading } = useSWR(key, fetcher, { refreshInterval: 60000 });
  return {
    canDownload: data?.can_download !== false,
    canEditSettings: data?.can_edit_settings !== false,
    canRenameDevices: data?.can_rename_devices !== false,
    canSetWifi: data?.can_set_wifi !== false,
    account: data?.account ?? null,
    managesAccounts: data?.manages_accounts === true,
    // Whether this server can send email (SMTP_HOST set). Off until the API
    // says otherwise, like managesAccounts: it only ever shows an option.
    emailEnabled: data?.email_enabled === true,
    isLoading
  };
}
